// extracted by mini-css-extract-plugin
export default {"heading":"AC-z","corrected":"BC-z","redirectVerbiageContainer":"CC-z","redirectVerbiageText":"DC-z"};